import React, { useCallback, useRef } from 'react';
import {
    createPopupReferenceFromEvent,
    PopupReference,
} from '@instinet-analytics/semantic-ui-components';

export function useBlotterContextMenu() {
    const [open, setOpen] = React.useState(false);
    const contextRef = useRef<PopupReference>();

    const onContextMenu = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault();
            contextRef.current = createPopupReferenceFromEvent(e);
            setOpen(true);
        },
        [contextRef, setOpen]
    );

    const onClose = useCallback(() => {
        setOpen(false);
    }, [setOpen]);

    return {
        onContextMenu,
        onCloseContextMenu: onClose,
        contextMenuOpen: open,
        contextMenuReference: contextRef.current,
    };
}
